"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipBase = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const React = tslib_1.__importStar(require("react"));
const styled_tools_1 = require("styled-tools");
const Popover_1 = require("./Popover");
const { forwardRef, useEffect, useRef, useState } = React;
const TooltipBaseComponent = forwardRef((props, refIn) => {
    const myRef = useRef(null);
    const ref = refIn === null ? myRef : refIn;
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const show = () => setVisible(true);
        const hide = () => setVisible(false);
        const node = ref.current;
        const parentNode = node === null ? undefined : node.parentNode === null ? undefined : node.parentNode;
        if (parentNode !== undefined && props.visible === undefined) {
            parentNode.addEventListener('mouseenter', show);
            parentNode.addEventListener('focus', show);
            parentNode.addEventListener('mouseleave', hide);
            parentNode.addEventListener('blur', hide);
        }
        return () => {
            if (parentNode !== undefined && props.visible === undefined) {
                parentNode.removeEventListener('mouseenter', show);
                parentNode.removeEventListener('focus', show);
                parentNode.removeEventListener('mouseleave', hide);
                parentNode.removeEventListener('blur', hide);
            }
        };
    }, [ref, setVisible, props.visible]);
    return React.createElement(Popover_1.Popover, Object.assign({}, props, { ref: ref, visible: props.visible === undefined ? visible : props.visible }));
});
exports.TooltipBase = styled_1.default(TooltipBaseComponent) `
  ${styled_tools_1.theme('TooltipBase')};
`;
exports.TooltipBase.defaultProps = {
    role: 'tooltip',
    placement: 'top',
    opaque: true,
    palette: 'grayscale',
};

//# sourceMappingURL=TooltipBase.js.map
